import React, {useEffect, useState} from 'react';
import './output.css';
import './App.sass';
import Loading from "./components/Loading";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Base from "./layout/Base";
import ScrollToHash from "./util/ScrollToHash";
import {useSelector} from "react-redux";
import FadeAnimation from "./util/FadeAnimation";
import {IAppState} from "./interface/redux/IAppState";



function App() {

    const theme = useSelector((state: IAppState) => state.setup.theme);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false)
        }, 1000);
        return () => {
            clearTimeout(timer);
        }
    }, []);

    if (loading) {
        return <Loading/>;
    }

    return (
        <div className={"App " + (theme === "dark" ? 'dark' : '')}>
            <div className="min-h-full flex flex-col">
                {/*<BrowserRouter basename={'/www/kernis'}>*/}
                <BrowserRouter>
                    <FadeAnimation/>
                    <ScrollToHash>
                        <Routes>
                            <Route path="/*" element={<Base/>}/>
                        </Routes>
                    </ScrollToHash>
                </BrowserRouter>
            </div>
        </div>
    );
}

export default App;
